import { useNavigate } from 'react-router-dom';

import { useAdaptationPlans, useAdaptationStories } from '@services/query.service';
import { useTranslation } from '@utils/i18n/i18n.consumers';
import { getImageUrl } from '@services/utils.service';

import { getSummaryStatistics } from './admin-overview.utils';

import './admin-overview.styl';

function AdminOverview() {
  const { data: adaptationPlans } = useAdaptationPlans();
  const { data: adaptationStories } = useAdaptationStories();

  const navigate = useNavigate();
  const { t } = useTranslation();

  const adaptationPlansSummary = getSummaryStatistics(adaptationPlans);
  const adaptationStoriesSummary = getSummaryStatistics(adaptationStories);

  return (
    <div className="admin-overview">
      <h2>{t('Overview')}</h2>
      <div className="admin-overview__section">
        <div className="admin-overview__section__summary">
          <h3>
            {t('Adaptation plans')}
          </h3>
          <span>
            {t('Published: {{published}}', { published: adaptationPlansSummary.published })}
          </span>
          <span>
            {t('New: {{new}}', { new: adaptationPlansSummary.new })}
          </span>
          <span>
            {t('Unique creators: {{uniqueCreators}}', { uniqueCreators: adaptationPlansSummary.uniqueCreators })}
          </span>
        </div>
        <div className="admin-overview__section__content">
          <h3>{t('Most recent plans')}</h3>
          <div className="admin-overview__section__content__cards">
            {adaptationPlans?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))?.slice(0, 3).map(plan => (
              <div
                key={plan.id}
                className="admin-overview__section__content__cards__card z-depth-1"
                onClick={() => navigate(`/admin/plans/${plan.id}`)}
              >
                <img src={getImageUrl(plan)} alt={plan.translations.en.title} />
                <span className="ellipsis" title={plan.translations.en.title}>{plan.translations.en.title}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="admin-overview__section">
        <div className="admin-overview__section__summary">
          <h3>
            {t('Adaptation stories')}
          </h3>
          <span>
            {t('Published: {{published}}', { published: adaptationStoriesSummary.published })}
          </span>
          <span>
            {t('New: {{new}}', { new: adaptationStoriesSummary.new })}
          </span>
          <span>
            {t('Unique creators: {{uniqueCreators}}', { uniqueCreators: adaptationStoriesSummary.uniqueCreators })}
          </span>
        </div>
        <div className="admin-overview__section__content">
          <h3>{t('Most recent stories')}</h3>
          <div className="admin-overview__section__content__cards">
            {adaptationStories?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))?.slice(0, 3).map(story => (
              <div
                key={story.id}
                className="admin-overview__section__content__cards__card z-depth-1"
                onClick={() => navigate(`/admin/stories/${story.id}`)}
              >
                <img src={getImageUrl(story)} alt={story.translations.en.title} />
                <span className="ellipsis" title={story.translations.en.title}>{story.translations.en.title}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminOverview;
